import CarrierServiceOptions from './view_modules/carrier_service_options';
import CourierSlots from './view_modules/courier_slots';
import InventoryMovements from './view_modules/inventory_movements';
import ShipsByDateService from "./view_modules/ships_by_dates";
import MsbdHistoryService from "./view_modules/msbd_histories";
import ShipmentSelectSlot from './view_modules/shipment_select_slot';
import WarehouseShow from './view_modules/warehouse_show';
import SearchWarehouseProductsService from './view_modules/warehouse_trading_partner_variants';
import ShipmentSearchService from "./view_modules/shipment_search";
import GeodisDashboardSearchService from "./view_modules/geodis_dashboard_search";
import WarehouseWarehouseProductsService from "./view_modules/warehouse_warehouse_products_index";
import ProductManagement from "./view_modules/product_management";
import Variations from "./view_modules/variations";
import BulkShipmentSearchService from "./view_modules/bulk_shipment_search";
import Zones from "./view_modules/zones";

const Views = {
  init() {
    CarrierServiceOptions.init();
    CourierSlots.init();
    InventoryMovements.init();
    ShipsByDateService.init();
    MsbdHistoryService.init();
    ShipmentSelectSlot.init();
    WarehouseShow.init();
    SearchWarehouseProductsService.init();
    ShipmentSearchService.init();
    GeodisDashboardSearchService.init();
    WarehouseWarehouseProductsService.init();
    ProductManagement.init();
    Variations.init();
    BulkShipmentSearchService.init();
    Zones.init();
  },
};

export default Views;
